<script>
import * as echarts from 'echarts'

export default {
  name: 'UChart',
  props: {
    rate: {
      type: String,
      default: '0',
    },
  },
  data () {
    return {
      id: 'fb-chart',
      charts: {},
    }
  },
  methods: {
    initChart (rate) {
      var option = {
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          show: true,
          data: ['风险值'],
          icon: 'round',
          textStyle: {
            color: '#777F8F',
            fontSize: 12
          },
          top: 0,
          left: '45%',
          itemHeight: 2,
          itemWidth: 20,
          itemGap: 6,
          zlevel: 100,
          selectedMode: false
        },
        grid: {
          left: '10%',
          right: '3%',
          bottom: '10%',
          top: '10%'
        },
        xAxis: {
          boundaryGap: false,
          axisLabel: {
            color: '#777F8F',
            interval: 0
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: 'true',
            lineStyle: {
              color: '#f5f5f5'
            }
          },
          data: ['风险值']
        },
        yAxis: {
          name: '',
          type: 'value',
          axisLabel: {
            color: '#777F8F'
          },
          minInterval: 1,
          max: 100,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#f5f5f5'
            }
          }
        },
        label: {
          position: 'top'
        },
        series: [{
          type: 'bar',
          name: '风险值',
          barWidth: 30,
          label: {
            position: 'top'
          },
          data: [rate]
        },],
        color: ['#6883FB', '#65D448']
      };
      this.drawChat('user_echarts', option);

    },
    drawChat (el, option) {
      const that = this
      const element = document.querySelector(`#${el}`)

      this.charts[el] = echarts.init(element);
      this.charts[el].setOption(option, true);
      window.onresize = (e) => {
        Object.entries(this.charts).forEach(item => {
          if (item) {
            item[1].resize({
              width: "auto",
              height: "auto"
            })
          }
        })
      };
    } // 绘制图表通用
  },
  mounted () {
    const val = Number(this.rate || 0)
    if (!Number.isNaN(val)) {
      this.initChart(val)
    }
  },
  watch: {
    rate (val) {
      const num = Number(val || 0)
      if (!Number.isNaN(num)) {
        this.initChart(num)
      }
    },
  },
}

</script>

<template>
  <div class="u-chart">
    <div id="user_echarts" class="charts"></div>
  </div>
</template>

<style lang="scss" scoped>
.u-chart {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 9;

  .charts {
    width: 100%;
    height: 100%;
  }
}
</style>
